import api from './index'
import { axios } from '@/utils/request'

export function createGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'create',
    method: 'POST',
    data: parameter
  })
}

export function createGrammarForSection(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'create_section_grammar',
    method: 'POST',
    data: parameter
  })
}

export function deleteGrammarForSection(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'delete_section_grammar',
    method: 'POST',
    data: parameter
  })
}

export function getListGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'list',
    method: 'GET',
    params: parameter
  })
}

export function getListSelfGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'list_self_grammar',
    method: 'GET',
    params: parameter
  })
}

export function getDetailGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'detail',
    method: 'GET',
    params: parameter
  })
}

export function updateGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteGrammar(parameter) {
  return axios({
    url: api.BaseURL + api.Grammar + 'delete',
    method: 'POST',
    data: parameter
  })
}